import { GridFilterItem } from "@platform/style";
import { CloseMassActionRequest, DateRange } from "../models/CloseMassActionRequest";
import { getOneDayAfter, getOneDayBefore } from "../utils/getDay";
import { AssignMassActionRequest } from "../models/AssignMassActionRequest";
import { ActionEnum } from "../models/ReasonsAndResolutions";

export function MassFilterGridRecords(
  action: string,
  reasonCode: string | undefined,
  comment: string | undefined,
  assignedTo: string | undefined,
  filterItems?: GridFilterItem[]
) {
  const closeMassActionRequest = {} as CloseMassActionRequest;
  const assignMassActionRequest = {} as AssignMassActionRequest;

  function setTitleProperty(
    action: string,
    item: GridFilterItem,
    closeMassActionRequest: CloseMassActionRequest,
    assignMassActionRequest: AssignMassActionRequest
  ) {
    let targetRequest;
    if (action === ActionEnum.CANCEL || action === ActionEnum.COMPLETE) {
      targetRequest = closeMassActionRequest;
    } else if (action === ActionEnum.ASSIGN) {
      targetRequest = assignMassActionRequest;
    }

    if (targetRequest) {
      if (item.operator === "contains") {
        targetRequest.TitleContains = item.value;
      } else {
        targetRequest.TitleEquals = item.value;
      }
    }
  }

  filterItems?.forEach((item) => {
    if (item.value?.trim() !== "" && item.value !== undefined) {
      switch (item.field) {
        case "CreatedDatetime":
        case "DueDate":
          const dateRange = {} as DateRange;
          if (item.operator == "is") {
            dateRange.StartDate = item.value;
            dateRange.EndDate = item.value;
          }
          if (item.operator == "after") {
            dateRange.StartDate = getOneDayAfter(item.value);
          }
          if (item.operator == "onOrAfter") {
            dateRange.StartDate = item.value;
          }
          if (item.operator == "onOrBefore") {
            dateRange.EndDate = item.value;
          }
          if (item.operator == "before") {
            dateRange.EndDate = getOneDayBefore(item.value);
          }

          if (action === ActionEnum.CANCEL || action === ActionEnum.COMPLETE) {
            item.field == "CreatedDatetime"
              ? (closeMassActionRequest.CreatedDateRange = dateRange)
              : (closeMassActionRequest.DueDateRange = dateRange);
          } else if (action === ActionEnum.ASSIGN) {
            item.field == "CreatedDatetime"
              ? (assignMassActionRequest.CreatedDateRange = dateRange)
              : (assignMassActionRequest.DueDateRange = dateRange);
          }
          break;

        case "FollowUpDate":
          if (action === ActionEnum.CANCEL || action === ActionEnum.COMPLETE) {
            closeMassActionRequest.FollowUpDate = item.value;
          } else if (action === ActionEnum.ASSIGN) {
            assignMassActionRequest.FollowUpDate = item.value;
          }
          break;

        case "Associations":
          if (action === ActionEnum.CANCEL || action === ActionEnum.COMPLETE) {
            closeMassActionRequest.Associations = new Array(item.value);
          } else if (action === ActionEnum.ASSIGN) {
            assignMassActionRequest.Associations = new Array(item.value);
          }
          break;

        case "BusinessFunction":
          let bfArr = item.value.split(",");
          if (action === ActionEnum.CANCEL || action === ActionEnum.COMPLETE) {
            closeMassActionRequest.BusinessFunctions = bfArr.map((s: string) => s.trim());
          } else if (action === ActionEnum.ASSIGN) {
            assignMassActionRequest.BusinessFunctions = bfArr.map((s: string) => s.trim());
          }
          break;

        case "Status":
          let statusArr = item.value.split(",");
          if (action === ActionEnum.CANCEL || action === ActionEnum.COMPLETE) {
            closeMassActionRequest.WorkItemStatuses = statusArr.map((s: string) => s.trim());
          } else if (action === ActionEnum.ASSIGN) {
            assignMassActionRequest.WorkItemStatuses = statusArr.map((s: string) => s.trim());
          }
          break;

        case "BusinessProcess":
          let bpArr = item.value.split(",");
          if (action === ActionEnum.CANCEL || action === ActionEnum.COMPLETE) {
            closeMassActionRequest.BusinessProcesses = bpArr.map((s: string) => s.trim());
          } else if (action === ActionEnum.ASSIGN) {
            assignMassActionRequest.BusinessProcesses = bpArr.map((s: string) => s.trim());
          }
          break;

        case "AssignedTo":
          let assignArr = item.value.split(",");
          if (action === ActionEnum.CANCEL || action === ActionEnum.COMPLETE) {
            closeMassActionRequest.Assignees = assignArr.map((s: string) => s.trim());
          } else if (action === ActionEnum.ASSIGN) {
            assignMassActionRequest.Assignees = assignArr.map((s: string) => s.trim());
          }
          break;

        case "Title":
          setTitleProperty(action, item, closeMassActionRequest, assignMassActionRequest);
          break;
      }
    }
  });

  !closeMassActionRequest.WorkItemStatuses
    ? (closeMassActionRequest.WorkItemStatuses = ["IN_PROGRESS", "ON_HOLD", "NEW"])
    : null;
  !!reasonCode && (closeMassActionRequest.ResolutionReasonCode = reasonCode);
  !!comment && (closeMassActionRequest.Comment = comment);

  !assignMassActionRequest.WorkItemStatuses
    ? (assignMassActionRequest.WorkItemStatuses = ["IN_PROGRESS", "ON_HOLD", "NEW"])
    : null;
  !!comment && (assignMassActionRequest.Comment = comment);
  !!assignedTo && (assignMassActionRequest.AssignToIdentifier = assignedTo);

  return action === ActionEnum.ASSIGN ? assignMassActionRequest : closeMassActionRequest;
}
